import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconDnsComponent } from "./med-icon-dns.component";

@NgModule({
  declarations: [
    MedIconDnsComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconDnsComponent,
  ],
})
export class MedIconDnsModule { }
